import { Component } from "react"
import PropTypes from "prop-types"
import { genericFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups.js"

// components
import { StateRegionFilter } from "shared/search/containers/Filter/Filters"

type Props = {
    displayLabel?: string
    filters?: Array<Component>
    helpText?: string
    uniqueFilterGroupId?: string
}

export const PacClassicPacOfficeFilterGroup = (props: Props) => genericFilterGroup(props)
PacClassicPacOfficeFilterGroup.defaultProps = {
    filters: [StateRegionFilter],
    uniqueFilterGroupId: "pacClassicPacOfficeFilterGroup",
    displayLabel: "State",
    helpText: "Filter by a single state or a group of states.",
}
